import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "lock",
  "use": "lock-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"lock\"><path d=\"M25 12h-2V9A7 7 0 009 9v3H7a1 1 0 00-1 1v16a1 1 0 001 1h18a1 1 0 001-1V13a1 1 0 00-1-1zM11 9a5 5 0 0110 0v3H11zm13 19H8V14h16z\" /><circle cx=\"16\" cy=\"22\" r=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/lock.svg
// module id = CNP7
// module chunks = 39 44